export default {
    baseStyle: {
        wrapper: {
            direction: {base: 'column', md: 'row'},
            align: {base: 'start', md: 'center'},
            alignItems: 'start',
            gap: '10px',
            flexWrap: 'wrap',
            paddingX: '15px',
            paddingY: '20px',
            marginY: '30px',
            background: 'white',
            border: '1px solid',
            borderColor: 'gray.500',
            borderRadius: '10px'
        },
        badge: {
            marginTop: '10px',
            fontSize: '11px',
            fontWeight: '500',
            height: '29px',
            padding: '8px 10px',
            textTransform: 'capitalize',
            borderRadius: '3px',
            letterSpacing: '0.055px',
            lineHeight: 'normal'
        }
    },
    sizes: {
        plp: {
            wrapper: {
                maxWidth: '900px',
                gap: {base: '10px', md: '40px'},
                marginX: {base: '15px', lg: '60px'},
                marginTop: '15px',
                marginBottom: {base: '15px', lg: '0px'},
                paddingX: {base: '15px', md: '20px'},
                paddingY: {base: '20px', md: '10px'},
                borderRadius: '10px'
            }
        },
        pdp: {
            wrapper: {
                margin: 0
            }
        }
    },
    variants: {
        yr: {
            badge: {
                background: 'black.300',
                color: 'white'
            }
        },
        ks: {
            badge: {
                background: 'yellow.600',
                color: 'black'
            }
        }
    },
    parts: ['wrapper', 'badge'],
    defaultProps: {
        variant: 'yr',
        size: 'pdp'
    }
}
